// extracted by mini-css-extract-plugin
export var compactFilters = "_ho-4";
export var detailImage = "_ho-1";
export var dropdownContainer = "_ho-2";
export var imageContainer = "_ho-0";
export var selectedCard = "_ho-3";